export default __webpack_public_path__ + "87bc46568a3704feee4a34a56485ddc7.svg";